const removeSuggestionTags = text => {
  const tempElement = document.createElement('div');
  tempElement.innerHTML = text;

  // Use a recursive function to remove the specific tags and keep the inner text
  const removeTags = element => {
    const unwantedTags = ['suggestion-start', 'suggestion-end'];
    unwantedTags.forEach(tag => {
      const elements = element.querySelectorAll(tag);
      elements.forEach(el => el.remove());
    });
    return element.textContent || element.innerText || '';
  };
  return removeTags(tempElement);
};
export default removeSuggestionTags;